/*
 * Header Messages
 *
 * This contains all the text for the Header component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.CustomerForm';

export default defineMessages({
  firstName: {
    id: `${scope}.firstName`,
    defaultMessage: 'Nome',
  },
  lastName: {
    id: `${scope}.lastName`,
    defaultMessage: 'Cognome',
  },
  email: {
    id: `${scope}.email`,
    defaultMessage: 'Email',
  },
  phone: {
    id: `${scope}.phone`,
    defaultMessage: 'Telefono',
  },
  fiscalCode: {
    id: `${scope}.fiscalCode`,
    defaultMessage: 'Codice fiscale',
  },
  fiscalCodeBusiness: {
    id: `${scope}.fiscalCodeBusiness`,
    defaultMessage: 'Codice fiscale attività',
  },
  fiscalCodeTooltip: {
    id: `${scope}.fiscalCodeTooltip`,
    defaultMessage: `Indicare il codice fiscale dell'attività a cui verrà intestato il contratto di noleggio a lungo termine`,
  },
  address: {
    id: `${scope}.address`,
    defaultMessage: 'Indirizzo',
  },
  postalCode: {
    id: `${scope}.postalCode`,
    defaultMessage: 'CAP',
  },
  contractualCategory: {
    id: `${scope}.contractualCategory`,
    defaultMessage: 'Categoria contrattuale',
  },
  businessName: {
    id: `${scope}.businessName`,
    defaultMessage: 'Ragione sociale',
  },
  vatNumber: {
    id: `${scope}.vatNumber`,
    defaultMessage: 'P.IVA',
  },
});
